module.exports = __webpack_public_path__ + "img/referencia7.a5927d5d.png";